const devTeam = [
	{
		value: "jalvarez@gca.digital",
		name: "José Álvarez"
	},
	{
		value: "btorres@gca.digital",
		name: "Brian Torres"
	},
	{
		value: "amontesdeoca@noddok.com",
		name: "Adrián Montes de Oca"
	},
	{
		value: "rmontesdeoca@noddok.com",
		name: "Roberto Montes de Oca"
	},
	{
		value: "jrojas@gca.digital",
		name: "Johanna Rojas"
	},
	{
		value: "na",
		name: "N/A"
	},
]

export default devTeam;
